import * as React from 'react';
type Props = {
  className?: string;
};
export function Sweets23({ className }: Props) {
  return (
    <svg
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-sweets-2-3"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4116 44.5641C1.88878 39.0072 -3.23978 16.7781 7.43162 15.6633C18.103 14.5481 23.8074 -3.5993 36.3974 2.4204C48.9879 8.4401 48.9869 26.5011 44.7897 33.9111C40.5931 41.3212 28.9345 50.121 15.4116 44.5641Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4116 44.5641C1.88878 39.0072 -3.23978 16.7781 7.43162 15.6633C18.103 14.5481 23.8074 -3.5993 36.3974 2.4204C48.9879 8.4401 48.9869 26.5011 44.7897 33.9111C40.5931 41.3212 28.9345 50.121 15.4116 44.5641Z"
        fill="#D6E4EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2257 10.829C18.9651 10.7517 18.7068 10.9108 18.6571 10.942C18.4386 11.0771 18.2176 11.3542 18.2636 11.6784C18.3139 12.0283 18.6378 12.1812 18.6583 12.19C18.9734 12.3318 19.3798 12.2283 19.5811 11.9716C19.8882 11.5785 19.6253 10.947 19.2257 10.829Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9112 14.2369C22.5721 14.1305 22.2405 14.3398 22.1756 14.3801C21.8945 14.5565 21.6111 14.9228 21.6757 15.3552C21.745 15.8214 22.1662 16.0286 22.193 16.0408C22.6034 16.2333 23.1283 16.1007 23.3858 15.7611C23.779 15.2423 23.4305 14.3995 22.9112 14.2369Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9169 8.98723C22.6723 9.2282 22.699 9.60574 22.7041 9.67904C22.7265 9.99869 22.9099 10.4069 23.3078 10.5485C23.7359 10.7016 24.1036 10.4369 24.127 10.4197C24.478 10.158 24.6035 9.65021 24.4313 9.27638C24.1685 8.70564 23.2914 8.61905 22.9169 8.98723Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1573 20.7458C19.8226 20.5467 19.7672 20.4687 19.5173 20.3149C19.2956 20.1794 18.9506 19.9675 18.5145 19.9099C18.2142 19.8702 18.2369 19.9524 17.6579 19.9794C17.0869 20.0061 16.7608 20.0169 16.4611 19.8169C16.2559 19.6805 16.1476 19.5012 16.0549 19.3487C15.8425 18.999 15.9021 18.8304 15.6618 18.4065C15.5889 18.2776 15.5053 18.1294 15.3534 17.9752C15.1197 17.7386 14.966 17.7307 14.5588 17.5023C14.1036 17.2469 13.8363 17.097 13.6976 16.7926C13.5945 16.566 13.603 16.3431 13.6112 16.1362C13.622 15.8469 13.6857 15.7907 13.7635 15.3852C13.8417 14.9752 13.8881 14.7348 13.8313 14.4395C13.7911 14.2274 13.6963 14.0533 13.5067 13.7045C13.2244 13.1859 13.1501 13.2103 13.0682 12.9456C13.0361 12.8398 12.9083 12.3829 13.1121 11.9546C13.1683 11.835 13.2533 11.7349 13.4221 11.535C13.6649 11.2476 13.8054 11.1613 13.9079 10.9287C13.9731 10.781 13.9912 10.6482 13.9974 10.5656C13.6091 10.5192 13.2161 10.4918 12.8137 10.5038C8.38056 10.6339 4.89194 14.3332 5.02191 18.7668C5.15197 23.1995 8.85173 26.6887 13.285 26.5582C16.7656 26.4559 19.6547 24.1507 20.677 21.0203C20.5512 20.962 20.3693 20.8719 20.1573 20.7458Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94475 17.7001C7.595 17.8105 7.43015 18.1864 7.39833 18.2598C7.25843 18.5782 7.22481 19.0593 7.5259 19.3914C7.84966 19.7489 8.32718 19.6751 8.35748 19.6703C8.81755 19.591 9.1899 19.1655 9.21677 18.7217C9.25759 18.0445 8.4805 17.5299 7.94475 17.7001Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0549 21.282C12.5977 21.4203 12.3865 21.9042 12.346 21.9978C12.1667 22.4073 12.1288 23.0285 12.5277 23.4612C12.957 23.9265 13.5818 23.8373 13.6217 23.8313C14.2241 23.7351 14.707 23.1903 14.7362 22.6177C14.7808 21.7437 13.7557 21.0694 13.0549 21.282Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.6903 14.2655C8.60044 14.7178 8.91599 15.1178 8.97697 15.1949C9.24409 15.5339 9.75633 15.8487 10.3061 15.706C10.8982 15.5522 11.1066 14.9794 11.1193 14.9431C11.3114 14.3858 11.0674 13.7266 10.5924 13.4415C9.86862 13.0057 8.82811 13.5725 8.6903 14.2655Z"
        stroke="currentColor"
      />
    </svg>
  );
}
